import React from 'react';
import PropTypes from 'prop-types';
import { StepHeading } from 'products/nomad_insurance/views/ClaimsForm/components/StepHeading/styled';
import { CLAIM_TYPES } from '../../../../consts';

const Heading = ({ claimType }) => {
  if (claimType === CLAIM_TYPES.TRAVEL) {
    return (
      <StepHeading>
        Travel information <span>(2 of 2)</span>
      </StepHeading>
    );
  }
  return (
    <StepHeading>
      Medical information <span>(3 of 3)</span>
    </StepHeading>
  );
};

Heading.propTypes = {
  claimType: PropTypes.string
};

export default Heading;
